import { SubscriptionName } from '@anm/api/modules/subscription';

import getOriginSubscriptionName from '../getOriginSubscriptionName';

const isSameSubscription = (first?: SubscriptionName, second?: SubscriptionName) =>
  !!first && !!second && getOriginSubscriptionName(first) === getOriginSubscriptionName(second);

export default isSameSubscription;
